import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';

import {YiitDirective} from './directives/yiit.directive';

@NgModule({
  declarations: [YiitDirective],
  providers: [],
  exports: [YiitDirective],
  imports: [CommonModule],
})
export class CoreModule {}
